(ns manage.adset-decision-tree-page.validation
  (:require [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [malli.core :as m]
            [malli.error :as me]
            [malli.util :as mu]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.sub :as-alias sub]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-schema-for-properties [properties properties-context]
  (reduce
   (fn [acc-schema {:keys [schema get-schema data-path required context]}]
     (let [schema (or (when get-schema
                        (get-schema (get properties-context context)))
                      schema)]
       (cond-> acc-schema
         (some? schema)
         (mu/assoc-in (cond->> data-path
                        (not required) (map (fn [field] [field {:optional true}])))
                      schema))))
   [:map]
   properties))

(def variant-schema (-> property/ad-variant-properties
                        property/resolve-properties
                        (get-schema-for-properties {})))

(def variants-schema [:sequential variant-schema])
(def variants-explainer (m/explainer variants-schema))

(defn validate-variants [ad-variants]
  (->> (map (fn [variant-error {:keys [uuid]}]
              [uuid variant-error])
            (me/humanize (variants-explainer ad-variants))
            ad-variants)
       (into {})))

(defhook use-node-type->explainer [properties-context available-nodes]
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {{:keys [channel]} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))]
    (uix/use-memo
     (fn []
       (->> available-nodes
            (map (fn [{node-type :type :keys [properties has-variants]}]
                   (let [properties* (-> (property/resolve-properties properties)
                                         (property/filter-properties-by-channel channel)
                                         (cond->
                                           has-variants (conj {:data-path property/ad-variants-data-path
                                                               :schema variants-schema})))]
                     [node-type
                      (-> properties*
                          (get-schema-for-properties properties-context)
                          m/explainer
                          (comp #(property/->validation properties* properties-context %)))])))
            (into {})))
     [properties-context channel available-nodes])))

(defhook use-node-errors [node-type->explainer node-data is-selected]
  (let [errors (uix/use-memo
                #(or (:warnings node-data)
                     (when-some [explainer (get node-type->explainer (:type node-data))]
                       (-> node-data explainer me/humanize)))
                [node-data node-type->explainer])]
    (and (not is-selected) errors)))
